// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RP2E","title":"Header_title__1jRtz","left":"Header_left__3FBcn","clinicName":"Header_clinicName__115fr"};